import React from "react";
import Modal from "../../../../elements/Modal";
import ManageEmailTemplate from "../ManageEmailTemplate";
import Drawer from "../../../../elements/Drawer";
import DrawerHeader from "../../../../elements/DrawerHeader";

const ManageEmailTemplateModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    // <Modal
    //   isOpen={open}
    //   setIsOpen={close}
    //   size="xl8"
    //   title={data?._id ? "Update One" : "Create New"}
    // >
    //   <ManageEmailTemplate
    //     getResponse={getResponse}
    //     close={close}
    //     data={data}
    //   />
    // </Modal>
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl4"}
      size={"xl4"}
      title={data?._id ? "Update" : "Create New "}
      subtitle="View, update and modify Email Template details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
      header={<DrawerHeader />}
    >
      <ManageEmailTemplate
        getResponse={getResponse}
        close={close}
        data={data}
      />
    </Drawer>
  );
};

export default ManageEmailTemplateModal;
